import { Outlet } from 'react-router-dom'

import NotFound from 'modules/core/components/NotFound'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { useSpendingPoliciesPage } from './useSpendingPolicies'

const SpendingPoliciesPage = () => {
  const { company } = useCurrentSession()
  const { data, loading, error } = useSpendingPoliciesPage(company.id)

  const canSeeSpendingPolicies = data?.finance?._policies?.spendingPoliciesSee?.can ?? false

  if (!loading && !canSeeSpendingPolicies) return <NotFound />
  return (
    <ResponsivePage.Body variant="wide" showHeader={false} loading={loading} error={error}>
      <Outlet />
    </ResponsivePage.Body>
  )
}

export default SpendingPoliciesPage
